import Main from './subPages/main';
import InvoiceMonthliesMain from './subPages/InvoiceMonthlies';
import InvoiceYearsMain from './subPages/InvoiceYears';
import InvoicesCertificated from './subPages/invoicesCertificateds';
import BlankPages from './subPages/blank';

const routes = [
  {
    path: '/invoices/*',
    canUse: [],
    Component: Main,
  },
  {
    path: '/blank-invoices/*',
    Component: BlankPages,
    props: {
      exact: true,
    },
  },
  {
    path: '/invoice_monthlies/*',
    Component: InvoiceMonthliesMain,
    props: {
      exact: true,
    },
  },
  {
    path: '/invoice_years/*',
    Component: InvoiceYearsMain,
    props: {
      exact: true,
    },
  },
  {
    path: '/certificateds/*',
    Component: InvoicesCertificated,
    props: {
      exact: true,
    },
  },
];

export default routes;
